import React from 'react';
import { ResponsiveValue, Theme } from 'styled-system';
import { Flex } from '@components/Flex';
import { Box } from '@components/Box';
import { getRootUrl } from '@utils/urlHelpers.util';
import { VideoWithStaticImages, VideoWithStaticImagesProps } from '@sections/rachel-zoe/components/VideoWithStaticImages';
import { rachelZoePageData } from '@data-ts/pages/rachel-zoe';
import { DisplayAboveMobile, DisplayOnMobile, StyledText, StyledCTALink } from './CuratedRegistrySection.styles';
import { CTALink } from '@components/CTALink';

const rachelZoeCuratedRegistryData = rachelZoePageData.sections.curatedRegistry;

export interface CurationProps {
  pageUrl: string;
  marginBottom?: ResponsiveValue<string | number, Theme>;
  videoImages: VideoWithStaticImagesProps;
  onClick?: () => void;
}

export const Curation: React.FC<CurationProps> = ({ pageUrl, marginBottom, videoImages, onClick }) => {
  return (
    <Flex marginBottom={marginBottom} flexDirection={['column-reverse', 'column']}>
      <VideoWithStaticImages {...videoImages} />
      <Box marginTop={[2, 7]} marginBottom={[2, 0]} style={{ textAlign: 'center' }}>
        <Flex justifyContent="center" marginBottom={[5, 0]}>
          <StyledText variant="hed40" color="neutra6" tagName="h2">
            {videoImages.title}
          </StyledText>
        </Flex>
        <DisplayAboveMobile>
          <StyledCTALink
            id="curatedRegistrySeeThisCuration"
            href={getRootUrl(pageUrl)}
            variant="neutraLink"
            typography="featureHed17"
            hasChevron
            onClick={onClick}
          >
            {rachelZoeCuratedRegistryData.seeThisCurationText}
          </StyledCTALink>
        </DisplayAboveMobile>
        <DisplayOnMobile>
          <CTALink
            id="curatedRegistrySeeThisCurationMobile"
            href={getRootUrl(pageUrl)}
            variant="primary"
            typography="featureHed17"
            hasChevron
            onClick={onClick}
          >
            {rachelZoeCuratedRegistryData.seeThisCurationText}
          </CTALink>
        </DisplayOnMobile>
      </Box>
    </Flex>
  );
};
